<template>
  <div class="flex-grow-1 padding">
    <div class="d-xl-flex">
      <FormInput v-model="$v.width.$model"
        class="form-element"
        id="width"
        :ske="true"
        label="Width"
        :vuelidate="$v"
        fieldName="width"
      />
      <FormInput v-model="$v.height.$model"
        class="form-element middle"
        id="height"
        :ske="true"
        label="Height"
        :vuelidate="$v"
        fieldName="height"
      />
      <FormInput v-model="$v.depth.$model"
        class="form-element"
        id="depth"
        :ske="true"
        label="Depth"

        :vuelidate="$v"
        fieldName="depth"
      />
    </div>
    <div class="d-xl-flex">
      <FormInput v-model="$v.weight.$model"
        class="form-element childPadding"
        id="weight"
        :ske="true"
        label="Weight"

        :vuelidate="$v"
        fieldName="weight"
      />
    </div>
  </div>
</template>

<script>

import FormInput from "../../../Inputs/FormInput.vue"

import setupForm from "../../../../mixins/setupForm"
import FormCheckbox from "../../../Inputs/FormCheckbox.vue"

const fields = ["width", "height", "depth", "weight"]
const decimal = value => (value + "").replace(/,/, ".").match(/^[-]?\d*(\.\d+)?$/) ? true : false
export default setupForm(fields, {
  props: {
    checkmail: Boolean,
  },
  components: {
    FormInput,
    FormCheckbox,
  },
  validations: {
    width: {
      decimal,
    },
    height: {
      decimal,
    },
    depth: {
      decimal,
    },
    weight: {
      decimal,
    },
  },
  watch: {
    checkmail(val) {
      if(val) {
        if(!this.$v.width.$model && !this.$v.height.$model && !this.$v.depth.$model && !this.$v.weight.$model) {
          this.$v.width.$model = 220
          this.$v.height.$model = 8
          this.$v.depth.$model = 220
          this.$v.weight.$model = 0.1
        }
        if(this.$v.width.$model >= 370 && this.$v.height.$model >= 31 && this.$v.depth.$model >= 255) {
          this.$v.width.$model = 220
          this.$v.height.$model = 8
          this.$v.depth.$model = 220
        }
      }
      else {
        if(this.$v.width.$model && this.$v.height.$model && this.$v.depth.$model && this.$v.weight.$model) {
          if(this.$v.width.$model <= 220 && this.$v.height.$model <= 8 && this.$v.depth.$model <= 220) {
            this.$v.width.$model = 375
            this.$v.height.$model = 32
            this.$v.depth.$model = 375
          }
        } else {
          this.$v.width.$model = ''
          this.$v.height.$model = ''
          this.$v.depth.$model = ''
          this.$v.weight.$model = ''
        }
      }
    }
  },
})

</script>

<style scoped src="@/assets/css/form.css"></style>
